import type { Temporal } from 'temporal-polyfill';
import type { useI18n } from 'vue-i18n';
import { isPastDateTime } from './dates';
import { formatRelativeTime } from './relative-time';

/**
 * Human-readable expiry label shared by the API key and pending-invite listings:
 * "Never expires" when there's no expiry, otherwise "Expires {relative}" / "Expired {relative}".
 */
export function formatExpiryLabel(expiresAt: Temporal.ZonedDateTime | null | undefined, i18n: ReturnType<typeof useI18n>): string {
	const { t } = i18n;

	if (!expiresAt) return t('expiry.never');

	const days = formatRelativeTime(expiresAt, i18n);

	return isPastDateTime(expiresAt)
		? t('expiry.expired', { days })
		: t('expiry.expires', { days });
}
